import { errorHandle } from 'redux/actions/error';
import apiService from 'shared/services/ApiService';
import {
  SET_LIST_BILLER,
  SET_BILLER,
  PROCESSING,
  PROCESSING_PREFIX,
  SET_LIST_BILLER_PREFIX,
  PROCESSING_PREFIX_DONE,
  SET_LIST_BILLER_BANK_ACCOUNT,
  PROCESSING_DONE,
} from './types';
const { allBillerApiService } = apiService.getInstance();

// Setter Payload Data
export const setListBiller = data => ({
  type: SET_LIST_BILLER,
  payload: data,
});

export const setBiller = data => ({
  type: SET_BILLER,
  payload: data,
});

export const setListBillerPrefix = data => ({
  type: SET_LIST_BILLER_PREFIX,
  payload: data,
});

// Getter Payload Data From API

export const getListBiller = (paginationUrl, paramUrl = '') => dispatch => {
  // Set Activity To Proccess
  dispatch({ type: PROCESSING });

  const billerUrl = `billers?${paginationUrl}${paramUrl}`;

  // Do Load Data Biller List
  allBillerApiService
    .get(billerUrl)
    .then(response => {
      if (response.status === 200) {
        const { payload, pagination } = response.data;
        dispatch({
          type: SET_LIST_BILLER,
          payload,
          pagination,
        });
      } else {
        dispatch({ type: SET_LIST_BILLER, payload: [], pagination: {} });
        errorHandle(response);
      }
    })
    .catch(error => {
      dispatch({ type: SET_LIST_BILLER, payload: [], pagination: {} });
      errorHandle(error);
    });
};

export const getBiller = (id, callback) => dispatch => {
  // Set Activity To Proccess
  dispatch({ type: PROCESSING });
  // Do Load Data Biller Detail
  allBillerApiService
    .get(`billers/${id}`)
    .then(response => {
      if (response.status === 200) {
        const { payload } = response.data;
        dispatch(setBiller(payload));
        callback(response, 'success');
      } else {
        errorHandle(response);
        dispatch(setBiller({}));
        callback(response, 'error');
      }
    })
    .catch(error => {
      errorHandle(error);
      dispatch(setBiller({}));
      callback(error, 'error');
    });
};

export const syncConsent = (billerData, type, dispatch, callback) => {
  const messageType = type === 'create' ? 'Create' : 'Update';
  allBillerApiService
    .post('dana/search/onboard', {
      entity_type: 'BILLER',
      entity_id: billerData.id,
    })
    .then(response => {
      if (response.status === 204) {
        dispatch(setBiller(billerData));

        callback(billerData.id, true, [
          {
            status: 'success',
            message: `${messageType} Biller: Success`,
          },
          // {
          //   status: 'success',
          //   message: 'Sync to Global Search: Success',
          // },
        ]);
      }
    })
    .catch(error => {
      callback(billerData.id, true, [
        {
          status: 'success',
          message: `${messageType} Biller: Success`,
        },
        // {
        //   status: 'failed',
        //   message: 'Sync to Global Search: Failed',
        //   info: error.response.data.message.detail,
        // },
      ]);
      dispatch(setBiller(billerData));
      errorHandle(error);
    });
};

export const billerCreate = (params, isSyncConsent, callback) => dispatch => {
  // Set Activity To Proccess
  dispatch({ type: PROCESSING });
  // Call Biller Create
  allBillerApiService
    .post('billers', params)
    .then(response => {
      if (response.status === 200) {
        const { payload } = response.data;
        dispatch(setBiller(payload));
        if (isSyncConsent) {
          syncConsent(payload, 'create', dispatch, callback);
        } else {
          callback(payload.id, true, [
            { status: 'success', message: 'Create Biller: Success' },
            // {
            //   status: 'pending',
            //   message: 'Sync to Global Search: Not Processed',
            // },
          ]);
        }
      }
    })
    .catch(error => {
      callback(null, false, [
        { status: 'failed', message: 'Create Biller: Failed' },
        // {
        //   status: 'pending',
        //   message: 'Sync to Global Search: Not Processed',
        // },
      ]);
      dispatch({ type: PROCESSING_DONE });
      errorHandle(error);
    });
};

export const billerUpdate = (
  id,
  params,
  isSyncConsent,
  callback,
) => dispatch => {
  // Set Activity To Proccess
  dispatch({ type: PROCESSING });
  allBillerApiService
    .patch(`billers/${id}`, params)
    .then(response => {
      if (response.status === 200) {
        const { payload } = response.data;
        dispatch(setBiller(payload));
        if (isSyncConsent) {
          syncConsent(payload, 'update', dispatch, callback);
        } else {
          callback(payload.id, true, [
            { status: 'success', message: 'Update Biller: Success' },
            // {
            //   status: 'pending',
            //   message: 'Sync to Global Search: Not Processed',
            // },
          ]);
        }
      }
    })
    .catch(error => {
      callback(null, false, [
        { status: 'failed', message: 'Update Biller: Failed' },
        // {
        //   status: 'pending',
        //   message: 'Sync to Global Search: Not Processed',
        // },
      ]);
      dispatch({ type: PROCESSING_DONE });
      errorHandle(error);
    });
};

export const billerCreatePrefix = (params, callback) => dispatch => {
  // Set Activity To Proccess
  dispatch({ type: PROCESSING_PREFIX });
  allBillerApiService
    .post('prefix', params)
    .then(response => {
      if (response.status === 200) {
        callback(response, 'success');
      } else {
        callback(response, 'error');
      }
      dispatch({ type: PROCESSING_PREFIX_DONE });
    })
    .catch(error => {
      dispatch({ type: PROCESSING_PREFIX_DONE });
      callback(error, 'error');
    });
};

export const updatePreferredPrefix = (id, callback) => dispatch => {
  // Set Activity To Proccess
  dispatch({ type: PROCESSING_PREFIX });
  allBillerApiService
    .patch(`prefix/${id}`, { priority: '1' })
    .then(response => {
      if (response.status === 200) {
        callback(response, 'success');
      } else {
        callback(response, 'error');
      }
      dispatch({ type: PROCESSING_PREFIX_DONE });
    })
    .catch(error => {
      dispatch({ type: PROCESSING_PREFIX_DONE });
      callback(error, 'error');
    });
};

export const getListBillerPrefix = id => dispatch => {
  // Set Activity To Proccess
  dispatch({ type: PROCESSING_PREFIX });
  const params = {
    page_num: 1,
    page_size: 100,
  };
  allBillerApiService
    .get(`billers/${id}/prefix`, { params })
    .then(response => {
      if (response.status === 200) {
        const { payload } = response.data;
        dispatch(dispatch(setListBillerPrefix(payload)));
      } else {
        dispatch(setListBillerPrefix([]));
        errorHandle(response);
      }
    })
    .catch(error => {
      dispatch(setListBillerPrefix([]));
      errorHandle(error);
    });
};

export const billerDeletePrefix = (prefixID, callback) => dispatch => {
  // Set Activity To Proccess
  dispatch({ type: PROCESSING_PREFIX });
  allBillerApiService
    .delete(`prefix/${prefixID}`)
    .then(response => {
      dispatch({ type: PROCESSING_PREFIX_DONE });
      callback(response, 'success');
    })
    .catch(error => {
      dispatch({ type: PROCESSING_PREFIX_DONE });
      callback(error, 'error');
    });
};

export const billerEditPrefix = (prefix, callback) => dispatch => {
  dispatch({ type: PROCESSING_PREFIX });

  allBillerApiService
    .patch(`prefix/${prefix.id}`, prefix)
    .then(response => {
      dispatch({ type: PROCESSING_PREFIX_DONE });
      callback(response, 'success');
    })
    .catch(error => {
      dispatch({ type: PROCESSING_PREFIX_DONE });
      callback(error, 'error');
    });
};

export const billerArchive = (
  idBiller,
  isArchive,
  isSyncConsent,
  callback,
) => () => {
  const params = `/billers/${idBiller}/${isArchive ? 'archive' : 'unarchive'}`;

  allBillerApiService
    .post(params)
    .then(response => {
      const { payload } = response.data;
      if (isSyncConsent) {
        const dispatch = () => {};
        syncConsent(payload, 'archive', dispatch, callback);
      } else {
        callback(payload.id, true, [
          {
            status: 'success',
            message: 'Update Biller: Success',
            info: 'This biller has been archived',
          },
          // {
          //   status: 'pending',
          //   message: 'Sync to Global Search: Not Processed',
          // },
        ]);
      }
    })
    .catch(error => {
      errorHandle(error);
      callback(null, false, [
        { status: 'failed', message: 'Update Biller: Failed' },
        // {
        //   status: 'pending',
        //   message: 'Sync to Global Search: Not Processed',
        // },
      ]);
    });
};

// eslint-disable-next-line no-unused-vars
export const getListBillerBankAccount = billerID => dispatch => {
  dispatch({ type: PROCESSING_PREFIX });
  dispatch({ type: PROCESSING_PREFIX_DONE });
};

export const billerCreateBankAccount = (params, callback) => (
  dispatch,
  getState,
) => {
  dispatch({ type: PROCESSING_PREFIX });

  const {
    listBillerBankAccount: newListBillerBankAccount,
  } = getState().allbiller;

  const newBankAccountId = Math.floor(Math.random() * 999999);

  const newBillerBankAccount = {
    id: newBankAccountId,
    bank_code: 111,
    bank_account: params.bank_account,
    bank_name: 'Static Bank Name For Testing',
  };

  newListBillerBankAccount.push(newBillerBankAccount);

  dispatch({
    type: SET_LIST_BILLER_BANK_ACCOUNT,
    payload: newListBillerBankAccount,
  });

  callback(
    {
      data: {
        payload: {
          id: newBankAccountId,
        },
      },
    },
    'success',
  );
  dispatch({ type: PROCESSING_PREFIX_DONE });
};

export const billerUpdatePreferredBankAccount = (bankAccountId, callback) => (
  dispatch,
  getState,
) => {
  dispatch({ type: PROCESSING_PREFIX });

  const { listBillerBankAccount } = getState().allbiller;

  let newBillerPreferredBankAccount;

  const newListBillerBankAccount = listBillerBankAccount.filter(
    (bankAccount, index) => {
      if (bankAccount.id === bankAccountId) {
        newBillerPreferredBankAccount = listBillerBankAccount[index];
      }
      return bankAccount.id !== bankAccountId;
    },
  );

  newListBillerBankAccount.unshift(newBillerPreferredBankAccount);

  dispatch({
    type: SET_LIST_BILLER_BANK_ACCOUNT,
    payload: newListBillerBankAccount,
  });

  callback({}, 'success');
  dispatch({ type: PROCESSING_PREFIX_DONE });
};

export const billerDeleteBankAccount = (bankAccountId, callback) => (
  dispatch,
  getState,
) => {
  dispatch({ type: PROCESSING_PREFIX });

  const { listBillerBankAccount } = getState().allbiller;

  const newListBillerBankAccount = listBillerBankAccount.filter(
    bankAccount => bankAccount.id !== bankAccountId,
  );

  dispatch({
    type: SET_LIST_BILLER_BANK_ACCOUNT,
    payload: newListBillerBankAccount,
  });

  callback({}, 'success');
  dispatch({ type: PROCESSING_PREFIX_DONE });
};
